import React from 'react';

const Spacer: React.VFC<{ width: number }> = ({ width }) => (
  <div style={{ width, display: 'inline-block' }} />
);

export default Spacer;
